import AddressInput from '_core/components/AddressInput';

export default AddressInput;
